import { withTrackedReducer } from '@angular-architects/ngrx-toolkit';
import { offshoreReportEvents } from '@navstation-portal/reporting/data-access/offshore-report';
import {
  getNameFromEventCode,
  getNameFromOperationCode,
} from '@navstation-portal/reporting/data-model/offshore-report';
import {
  INITIAL_OFFSHORE_REPORTS_STATE,
  ReducedOffshoreReport,
} from '@navstation-portal/reporting/data-model/offshore-reports';
import { signalStoreFeature } from '@ngrx/signals';
import { removeEntity, upsertEntities, upsertEntity } from '@ngrx/signals/entities';
import { on } from '@ngrx/signals/events';
import { offshoreReportsEvents } from './offshore-reports-events';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function withOffshoreReportsReducer<_>() {
  return signalStoreFeature(
    withTrackedReducer(
      on(offshoreReportsEvents.fetchReportsSuccess, ({ payload: reports }) => {
        reports.forEach((report) => {
          report.event = getNameFromEventCode(report.event) || '';
          report.operation = getNameFromOperationCode(report.operation) || '';
        });
        return upsertEntities(reports);
      }),
      on(offshoreReportEvents.createReportSuccess, ({ payload: { reportId, report } }) => {
        const reduced: ReducedOffshoreReport = {
          id: reportId,
          reportNumber: report.operational?.reportDetails?.reportNumber ?? -1,
          reportFrom: '',
          reportTo: '',
          reportPeriod: 0,
          event: '',
          operation: '',
          status: 'draft',
        };
        return upsertEntity(reduced);
      }),
      on(offshoreReportsEvents.reset, () => INITIAL_OFFSHORE_REPORTS_STATE),
      on(offshoreReportEvents.saveReportSuccess, ({ payload: { reportId, report } }) => {
        const event = getNameFromEventCode(report.operational?.reportOptions?.eventType ?? '') || '';
        const operation = getNameFromOperationCode(report.operational?.reportOptions?.operationType ?? '') || '';
        const reduced: ReducedOffshoreReport = {
          id: reportId,
          reportNumber: report.operational?.reportDetails?.reportNumber ?? -1,
          reportFrom: report.operational?.reportDetails?.reportFrom?.toISOString() ?? '',
          reportTo: report.operational?.reportDetails?.reportTo?.toISOString() ?? '',
          reportPeriod: report.operational?.reportDetails?.reportPeriod ?? 0,
          event,
          operation,
          status: 'draft',
        };
        return upsertEntity(reduced);
      }),
      on(offshoreReportEvents.deleteReportSuccess, ({ payload: reportId }) => {
        return removeEntity(reportId);
      })
    )
  );
}
